
					const modules = import.meta.glob([
  "/fake/business.fake.ts",
  "/fake/dashboard-operations.fake.ts",
  "/fake/gateway.fake.ts",
  "/fake/notices.fake.ts",
  "/fake/register.fake.ts",
  "/fake/user.fake.ts"
], { eager: true });
					const fakeModuleList = Object.keys(modules).reduce((list, key) => {
						const module = modules[key] ?? {};
						if (module.default) {
							for (const moduleKey of Object.keys(module)) {
								const mod = modules[key][moduleKey] ?? [];
								const modList = Array.isArray(mod) ? [...mod] : [mod];
								return [...list, ...modList];
							}
						} else {
							return list;
						}
					}, []);
					window.__VITE__PLUGIN__FAKE__SERVER__.fakeModuleList = fakeModuleList;
				